export default {
	readConfirmations: {
		seen: 'Seen',
		seenBy: 'Seen by',
		collectedSinceHint:
			'Read confirmations for documents are being collected since version 04.2026. Older reads are not included.',
		noReadConfirmations: 'No read confirmations yet.',
	},
}
